﻿//* Future goal: This frame will listen for spells being used by the player and play cool animations based on that spell. Maybe even play spell sounds?
// https://cloudkidstudio.github.io/PixiParticlesEditor/# Could create a particle effect for each spell.

class SpellEffectAddon {

}